var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "first-info-card d-flex flex-column gr-2",
      class: _setup.isMobile ? "px-4 py-12" : "pt-6 px-6 pb-3 rounded-sm",
    },
    [
      _vm.adminkaUrl
        ? _c(
            "a",
            {
              staticClass: "adminka align-self-start",
              attrs: {
                href: _vm.adminkaUrl,
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [_vm._v(_vm._s(_setup.t("править", _setup.options)))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "text-h6 bg-gray-0--text" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "first-info-card__html d-flex flex-column gr-3 text-body-2 bg-gray-0--text",
        domProps: {
          innerHTML: _vm._s(
            _vm.textHtml /* eslint-disable-line vue/no-v-html */
          ),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }